import createApiService from "@lib/create-api-service";
import { API_ROUTES } from "@utils/constants";

import validateLockersResponse, { TLockersResponse } from "../models/lockers";
import type { TMapLocker } from "../types";
import mapLockersResponse from "../utils/mapLockersResponse";

const getLockers = createApiService<TLockersResponse>({ method: "GET", url: API_ROUTES.LOCKERS });

const loadLockers = async (
  countryCode: string,
  searchQuery?: string,

  errCallback?: (message?: string) => void
): Promise<TMapLocker[]> => {
  try {
    const response = await getLockers({ params: { countryCode, search: searchQuery } });
    if (!response.isSuccess) {
      errCallback?.(response.errorMessage);
      return [];
    }

    const validResponse = validateLockersResponse(response.data ?? []);
    return mapLockersResponse(validResponse);
  } catch (err) {
    errCallback?.();
    return [];
  }
};
export default loadLockers;
